export default {
  RemoveCarExtra: 'تعرفه خودرو حذف شد',
  NewExtraCarAdd: 'تعرفه جدید خودرو اضافه شد',
  NewTariffAdd: 'تعرفه جدید اضافه شد',
  RemoveTariff: 'تعرفه خذف شد',

  TariffUpdate: 'تعرفه بروزرسانی شد',
  RemoveItemExtra: 'تعرفه اقلام حذف شد',
  NewExtraItemAdd: 'تعرفه جدید اقلام اضافه شد',
  NewExtraEmployeeAdd: 'تعرفه جدید افراد اضافه شد',
  ExtraItemUpdate: 'تعرفه اقلام بروزرسانی شد',

  Amount: 'مقدار',
  FreeAmount: ' میزان تخفیف',
  FreeAmountMin: 'مقدار رایگان از',
  FreeAmountMax: 'مقدار رایگان تا',
  CarModel: 'نوع خودرو',
  CompanyLogo: 'لوگوی باربری',
  CarOption: 'قابلیت خودرو',
  Cost: 'هزینه',
  CostMin: 'هزینه از',
  CostMax: 'هزینه تا',
  Company: 'باربری',
  CompanyName: 'نام باربری',
  Count: 'تعداد',
  DiscountPercent: 'درصد تخفیف',
  ExtraCarUpdate: 'تعرفه خودرو بروزرسانی شد',
  ExtraCostMin: 'هزینه ساعت اضافه از',
  ExtraCostMax: 'هزینه ساعت اضافه تا',
  ExtraKilometerCost: 'هزینه هر کیلومتر اضافه',
  ExtraKilometerCostMin: 'هزینه هر کیلومتر اضافه از',
  ExtraKilometerCostMax: 'هزینه هر کیلومتر اضافه تا',
  ExtraKilometerCommissionPercent: 'درصد کمیسیون هرکیلومتر اضافه',
  Employee: 'افراد',
  CostPerHourAdded: 'هزینه هر ساعت اضافه',
  Enable: 'فعال',
  TimeService: 'زمان سرویس دهی',
  Tariff: 'تعرفه',
  ExtraHourCost: 'هزینه هر ساعت اضافه',
  Km: 'کیلومتر',
  LaborCost: 'هزینه کارگر',
  LaborerCostMin: 'هزینه کارگر از',
  LaborerCostMax: 'هزینه کارگر تا',
  LaborerExtraHourCost: 'هزینه هر ساعت اضافه کاری کارگر',
  LaborerExtraHourCostMin: 'هزینه ساعت اضافه کاری کارگر از',
  LaborerExtraHourCostMax: 'هزینه ساعت اضافه کاری کارگر تا',
  Holiday: 'تعطیلات',
  Item: 'اقلام',
  Disable: 'غیر فعال',
  Hour: 'ساعت',
  PackSizeMin: 'واحد اضافه نرخ از',
  PackSizeMax: 'واحد اضافه نرخ تا',
  serviceHourMin: 'زمان سرویس دهی از',
  serviceHourMax: 'زمان سرویس دهی تا',
  ServiceKilometer: 'مسافت پایه',
  ServiceKilometerMin: 'مسافت پایه از',
  ServiceKilometerMax: 'مسافت پایه تا'
}
